import { render, staticRenderFns } from "./PropagationConfirmModal.vue?vue&type=template&id=6359aba8&scoped=true&"
import script from "./PropagationConfirmModal.vue?vue&type=script&lang=js&"
export * from "./PropagationConfirmModal.vue?vue&type=script&lang=js&"
import style0 from "./PropagationConfirmModal.vue?vue&type=style&index=0&id=6359aba8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6359aba8",
  null
  
)

export default component.exports